import { ReactNode } from 'react';

import {
  CodeActions,
  CodeActionsProps,
  PreviewYaml as DsPreviewYaml,
  PreviewYamlProps,
} from '@cast/design-system';

import { CopyCode } from './CopyCode';

export const PreviewYaml = ({
  actionsProps = {},
  actions = <CopyCode />,
  ...props
}: PreviewYamlProps & {
  actionsProps?: Partial<CodeActionsProps>;
  actions?: ReactNode;
}) => {
  return (
    <DsPreviewYaml {...props}>
      <CodeActions {...actionsProps}>{actions}</CodeActions>
    </DsPreviewYaml>
  );
};
